import scrollbarWidth from '@mvsde/scrollbar-width'

/**
 * Disable scrolling
 *
 * Sets padding-right on body to avoid page jumping
 * after scrollbar has been removed
 */
function disableScrolling () {
  const paddingRight = `${scrollbarWidth({ testOverflow: true })}px`

  document.body.style.paddingRight = paddingRight
  document.body.style.overflowY = 'hidden'
}

/**
 * Enable scrolling
 *
 * Reset body padding and overflow
 */
function enableScrolling () {
  document.body.style.paddingRight = ''
  document.body.style.overflowY = ''
}

export { disableScrolling, enableScrolling }
